<template>

<div class="section" :class="{'is-active': isActive, 'is-flag': flag, [iconClass]: true}">
	
	<div class="section-title" v-if="!window.is.mobile">{{ ($isPatient && section.patient && section.patient.title) ? section.patient.title : section.text.title }}</div>

	<div class="section-badge">

		<div class="section-badge-icon" v-on:click="onBadgeClick"></div>

	</div>

</div>

</template>

<script>

export default {

	props: ['section', 'active'],

	computed: {

		isActive: function() {

			return this.section.id === this.active

		},

		iconClass: function() {

			return 'icon-' + this.$constants.icon[this.section.icon]

		},

		flag: function() {

			if (this.currentAlert && this.isActive) {

				var type = (this.currentAlert === true) ? this.$store.getters['session/alerts/dynamic'].type : this.alerts[this.currentAlert]

				return this.$_.contains([this.$constants.alert.type.warning, this.$constants.alert.type.error], type)

			} else {

				return false

			}

		}

	},

	methods: {

		onBadgeClick: function() {

			if (this.section.glossary) {

				this.$emit('glossary')
				return

			}

			if (!this.isActive) {

				this.$store.dispatch('back', this.section.id)

			}

		}

	}

}

</script>

<style scoped>

.section {
	display: flex;
	flex-direction: row;
	align-items: center;
	height: 72px;
	margin-bottom: 24px;
	transition: all 300ms ease-in-out;
	flex-shrink: 0;
}

.is-mobile .section {
	height: 40px;
	width: 40px;
	margin-bottom: 0px;
}

.section.is-active {
	height: 100px;
}

.is-mobile .section.is-active {
	height: 40px;
}

.section-title {
	color: #343434;
	font-size: 14px;
	text-transform: uppercase;
	font-weight: 700;
	line-height: 16px;
	letter-spacing: 1px;
	text-align: right;
	padding-right: 72px;
	width: 100%;
	transition: all 300ms ease-in-out;
}

.is-tablet .section-title,
.is-mobile .section-title {
	display: none;
}

.is-dark .section-title {
	color: #fff;
}

.section.is-active .section-title {
	font-size: 14px;
	line-height: 16px;
}

.section-badge {
	position: absolute;
	height: 72px;
	width: 72px;
	top: 0px;
	right: -36px;
	border-radius: 50%;
	background-color: var(--primary-color);
	border: 4px solid #fff;
	transition: all 300ms ease-in-out;
}

.is-aiding .section-badge {
	background-color: var(--aid-color);
}

.is-mobile .section-badge {
	width: 40px;
	height: 40px;
	right: 0px;
	border: 2px solid #fff;
}

.is-dark .section-badge {
	border-color: #343434;
}

.section-badge-icon {
	width: 100%;
	height: 100%;
	background-color: #434343;
	transition: all 300ms ease-in-out;
	mask-position: 50% 50%;
	mask-repeat: no-repeat;
    mask-size: 32px 32px;
}

.is-mobile .section-badge-icon {
	mask-size: 20px 20px;
}

.section:not(.is-active) .section-badge-icon {
	cursor: pointer;
}

.section.is-active .section-badge {
	height: 100px;
	width: 100px;
	background-color: #434343;
	right: -50px;
}

.is-mobile .section.is-active .section-badge {
	width: 40px;
	height: 40px;
	right: 0px;
}

.section.is-flag .section-badge {
	background-color: #714CEB;
}

.section.is-active .section-badge-icon {
	width: 100%;
	height: 100%;
	mask-size: 56px 56px;
	background-color: #ffffff;
}

.is-mobile .section.is-active .section-badge-icon {
	mask-size: 20px 20px;
}

.is-not-mobile .section:before,
.is-not-mobile .section:last-child:after {
	position: absolute;
	content: ' ';
	width: 12px;
	height: 32px;
	bottom: calc(100% - 4px);
	right: -4px;
	background-color: #fff;
	transition: all 300ms ease-in-out;
}

.is-not-mobile .is-dark .section:before,
.is-not-mobile .is-dark .section:last-child:after {
	background-color: #343434;
}

.is-not-mobile .section-badge:before,
.is-not-mobile .section:last-child .section-badge:after {
	position: absolute;
	content: ' ';
	width: 16px;
	height: 28px;
	bottom: calc(100% + 2px);
	right: 50%;
	background-color: #8AD7FF;
	border-radius: 0px 16px 16px 0px;
	transition: all 300ms ease-in-out;
}

.is-patient .section-badge:before,
.is-patient .section:last-child .section-badge:after {
	background-color: #FFD6A6;
}

.is-not-mobile .is-dark .section-badge:before,
.is-not-mobile .is-dark .section:last-child .section-badge:after {
	background-color: #5C5C5C;
}

.is-tablet .is-dark .section-badge:before,
.is-tablet .is-dark .section:last-child .section-badge:after,
.is-mobile .is-dark .section-badge:before,
.is-mobile .is-dark .section:last-child .section-badge:after {
	background-color: #5C5C5C;
}

.is-not-mobile .section:first-child:before {
	height: 16px;
}

.is-not-mobile .section:first-child .section-badge:before {
	border-radius: 0px 0px 16px 0px;
}

.is-not-mobile .section:last-child:after {
	height: 16px;
	bottom: auto;
	top: calc(100% - 4px);
	z-index: 1;
}

.is-not-mobile .section:last-child .section-badge:after {
	border-radius: 0px 16px 0px 0px;
	bottom: auto;
	top: calc(100% + 2px);
	z-index: 2;
}

.is-not-mobile .is-mobile .section:last-child .section-badge:after {
	top: calc(100% + 2px);
}

.section.icon-person .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0Ny40NzciIGhlaWdodD0iNTEuNTM0IiB2aWV3Qm94PSIwIDAgNDcuNDc3IDUxLjUzNCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6M3B4O308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUgMS41KSI+PGNpcmNsZSBjbGFzcz0iYSIgc3Ryb2tlPSIjZmZmZmZmIiBjeD0iMTMuNzY3IiBjeT0iMTMuNzY3IiByPSIxMy43NjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDguNDcxKSIvPjxwYXRoIGNsYXNzPSJhIiBzdHJva2U9IiNmZmZmZmYiIGQ9Ik0xMjcuMzg4LDExOC42MzlhMTUuNTUzLDE1LjU1MywwLDAsMSwxNS41NTMtMTUuNTU0aDEzLjM3MWExNS41NTMsMTUuNTUzLDAsMCwxLDE1LjU1NCwxNS41NTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjcuMzg4IC03MC4xMDUpIi8+PC9nPjwvc3ZnPg==");
}

.section.icon-lungs .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MC45MjciIGhlaWdodD0iNDUuMTI2IiB2aWV3Qm94PSIwIDAgNTAuOTI3IDQ1LjEyNiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6MnB4O308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzQ2LjQzMyAtMTgwLjQ2MSkiPjxwYXRoIGNsYXNzPSJhIiBkPSJNMzY2LjQ1MiwyMDMuNjQ4djguNjVhMTEuMTc2LDExLjE3NiwwLDAsMS01LjY1Myw5LjcxNmwtMi4xNjgsMS4yMzFjLTUuOTI0LDMuMzY2LTEwLjYxMy0uMzUyLTExLjE2NC03LjE0NXEtLjAzNS0uNDE1LS4wMzQtLjg0MVYyMDQuODJjMC0xMC43NjcsNS43LTE5LjUsMTYuNDY5LTE5LjVoMGEyLjU1LDIuNTUsMCwwLDEsMi41NSwyLjU1djMuOTQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuMDM1KSIvPjxwYXRoIGNsYXNzPSJhIiBkPSJNMzc3LjA3LDIwMy42NDh2OC42NWExMS4xNzcsMTEuMTc3LDAsMCwwLDUuNjU0LDkuNzE2bDIuMTY3LDEuMjMxYzUuOTI0LDMuMzY2LDEwLjYxNC0uMzUyLDExLjE2NS03LjE0NS4wMjItLjI3Ny4wMzQtLjU1Ny4wMzQtLjg0MVYyMDQuODJjMC0xMC43NjctNS43LTE5LjUtMTYuNDY5LTE5LjVoMGEyLjU1LDIuNTUsMCwwLDAtMi41NTEsMi41NXYzLjk0OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4yNyAwLjAzNSkiLz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNjMuMzQyIDE4MS40NjEpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTM3MS43NTIsMTgxLjQ2MXYxMS42YTQuNzQ3LDQuNzQ3LDAsMCwxLTQuNzQ3LDQuNzQ3SDM2My4yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzYzLjE5OCAtMTgxLjQ2MSkiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTM3MS42NzUsMTgxLjQ2MXYxMS42YTQuNzQ3LDQuNzQ3LDAsMCwwLDQuNzQ3LDQuNzQ3aDMuODA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzYzLjEyMSAtMTgxLjQ2MSkiLz48L2c+PC9nPjwvc3ZnPg==");
}

.section.icon-rx .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS44MzQiIGhlaWdodD0iMzAuOTU2IiB2aWV3Qm94PSIwIDAgMjUuODM0IDMwLjk1NiI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6IzM0MzQzNDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQxNy44NCAtMTgxLjA0OSkiPjxwYXRoIGNsYXNzPSJhIiBkPSJNNDE4Ljg1NSwxOTQuMjg2VjE4Mi4wNDloMTAuNTU4YTYuMiw2LjIsMCwwLDEsMCwxMi40bC0xMC41NTgtLjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIi8+PGxpbmUgY2xhc3M9ImEiIHgyPSIxNC4yNDUiIHkyPSIxNi4wNzgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQyOC4wMTcgMTk0LjUxNSkiLz48bGluZSBjbGFzcz0iYSIgeTI9IjExLjA4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MTguODU1IDE5NC4yODYpIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSI3LjEyMiIgeTI9IjguMDM5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MjguMDE3IDIwMi41NTQpIi8+PGxpbmUgY2xhc3M9ImEiIHgxPSI0LjI2IiB5Mj0iNC44MDkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQzOC4wMDIgMTk0LjUxNSkiLz48L2c+PC9zdmc+");
}

.section.icon-stethoscope .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS4yMzIiIGhlaWdodD0iMzMuOTg3IiB2aWV3Qm94PSIwIDAgMjUuMjMyIDMzLjk4NyI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6bm9uZTtzdHJva2U6IzM0MzQzNDtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE5Ni44OTkgLTY3LjA1KSI+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMTUuMDIzLDk1LjM3OXYxMC4xNmE1LjAyLDUuMDIsMCwwLDEtNS4wMiw1LjAyMUgyMDguODJhNS4wMiw1LjAyLDAsMCwxLTUuMDItNS4wMjF2LTIuOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuMjcyIC0xMC41MjIpIi8+PGNpcmNsZSBjbGFzcz0iYSIgY3g9IjMuNjI5IiBjeT0iMy42MjkiIHI9IjMuNjI5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxOTcuODk5IDg0Ljg1NykiLz48cGF0aCBjbGFzcz0iYSIgZD0iTTIyMy4yNjEsNjguMDVoMS45MjJ2OC40MjhhOC4zNzksOC4zNzksMCwwLDEtOC4zNzksOC4zNzloMGE4LjM3OSw4LjM3OSwwLDAsMS04LjM3OS04LjM3OVY2OC4wNWgxLjkyMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQuMDUzKSIvPjwvZz48L3N2Zz4=");
}

.section.icon-star .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMSIgaGVpZ2h0PSIyOS40ODMiIHZpZXdCb3g9IjAgMCAzMSAyOS40ODMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiMzNDM0MzQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yNzQuMDU4LDY4LjU1Nmw0LjEyNiw4LjM2LDkuMjI1LDEuMzQxLTYuNjc2LDYuNTA3LDEuNTc2LDkuMTg4LTguMjUxLTQuMzM4LTguMjUxLDQuMzM4LDEuNTc2LTkuMTg4LTYuNjc2LTYuNTA3LDkuMjI1LTEuMzQxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI1OC41NTggLTY2LjI5NikiLz48L3N2Zz4=");
}

.section.icon-check .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MS40NzgiIGhlaWdodD0iNDYuNDk0IiB2aWV3Qm94PSIwIDAgNTEuNDc4IDQ2LjQ5NCI+PGRlZnM+PHN0eWxlPi5hLC5ie2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbGluZWNhcDpyb3VuZDtzdHJva2UtbGluZWpvaW46cm91bmQ7c3Ryb2tlLXdpZHRoOjNweDt9LmF7c3Ryb2tlLW1pdGVybGltaXQ6MTA7fTwvc3R5bGU+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOS42ODYgLTE1Mi45NzMpIj48cGF0aCBjbGFzcz0iYSIgZD0iTTQ3Ljk4NSwxNjEuOTYxbDExLjMsMTYuNDExLDI4LjQxLTMzLjUyMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4zNTYgMTAuMjM3KSIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNNzYuMTMxLDE4OC4wMjlWMTk5LjlINDEuMTg2VjE2NC45NTZINzAuMTkxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0xLjkzNikiLz48L2c+PC9zdmc+");
}

.section.icon-density .section-badge-icon {
	mask-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzOC4wOTciIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzOC4wOTcgMzYiPjxkZWZzPjxzdHlsZT4uYSwuY3tmaWxsOm5vbmU7fS5he3N0cm9rZTojMDQwNDA1O3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDoycHg7fS5ie3N0cm9rZTpub25lO308L3N0eWxlPjwvZGVmcz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjU0LjQ4NCAtMzkzLjI4NikiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI1NC40ODQgNDA1LjQxKSI+PGcgY2xhc3M9ImEiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI1Ljg3NiIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI0Ljg3NiIvPjwvZz48ZyBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuMTcyKSI+PGNpcmNsZSBjbGFzcz0iYiIgY3g9IjUuODc2IiBjeT0iNS44NzYiIHI9IjUuODc2Ii8+PGNpcmNsZSBjbGFzcz0iYyIgY3g9IjUuODc2IiBjeT0iNS44NzYiIHI9IjQuODc2Ii8+PC9nPjxnIGNsYXNzPSJhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNi4zNDQpIj48Y2lyY2xlIGNsYXNzPSJiIiBjeD0iNS44NzYiIGN5PSI1Ljg3NiIgcj0iNS44NzYiLz48Y2lyY2xlIGNsYXNzPSJjIiBjeD0iNS44NzYiIGN5PSI1Ljg3NiIgcj0iNC44NzYiLz48L2c+PC9nPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI2MS4wNyAzOTMuMjg2KSI+PGcgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDApIj48Y2lyY2xlIGNsYXNzPSJiIiBjeD0iNS44NzYiIGN5PSI1Ljg3NiIgcj0iNS44NzYiLz48Y2lyY2xlIGNsYXNzPSJjIiBjeD0iNS44NzYiIGN5PSI1Ljg3NiIgcj0iNC44NzYiLz48L2c+PGcgY2xhc3M9ImEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzLjE3MikiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI1Ljg3NiIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI0Ljg3NiIvPjwvZz48L2c+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYxLjA3IDQxNy41MzMpIj48ZyBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCkiPjxjaXJjbGUgY2xhc3M9ImIiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI1Ljg3NiIvPjxjaXJjbGUgY2xhc3M9ImMiIGN4PSI1Ljg3NiIgY3k9IjUuODc2IiByPSI0Ljg3NiIvPjwvZz48ZyBjbGFzcz0iYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMuMTcyKSI+PGNpcmNsZSBjbGFzcz0iYiIgY3g9IjUuODc2IiBjeT0iNS44NzYiIHI9IjUuODc2Ii8+PGNpcmNsZSBjbGFzcz0iYyIgY3g9IjUuODc2IiBjeT0iNS44NzYiIHI9IjQuODc2Ii8+PC9nPjwvZz48L2c+PC9zdmc+");
}

.section.icon-speech .section-badge-icon {
	mask-image: url(~@/assets/icon.speech.svg);
}

.section.icon-cross .section-badge-icon {
	mask-image: url(~@/assets/icon.cross.svg);
}

.section.icon-question .section-badge-icon {
	mask-image: url(~@/assets/icon.question.svg);
}

.section.icon-improve .section-badge-icon {
	mask-image: url(~@/assets/icon.improve.svg);
}

.section.icon-summary .section-badge-icon {
	mask-image: url(~@/assets/icon.summary.svg);
}

.section.icon-book .section-badge-icon {
	mask-image: url(~@/assets/icon.book.svg);
}

</style>